// REACT
import { NavLink } from "react-router-dom";

// ASSETS
import { Card } from "react-bootstrap";
import { FaUpload, FaFileExport, FaBox, FaExclamationTriangle, FaClipboardList, FaStoreAlt } from "react-icons/fa";
import "../../assets/styles/toolCard.css";

// COMPONENTS
import Loading from "../common/Loading";

export default function ToolCard({ url, toolName, toolTitle, count, loading }) {
    // Map tool names to corresponding icons
    const iconMap = {
        "Upload Manager": <FaUpload className="tool-icon text-info " />,
        "Export Manager": <FaFileExport className="tool-icon text-success" />,
        "Product Manager": <FaClipboardList className="tool-icon text-primary  " />,
        "Shop Manager": <FaStoreAlt className="tool-icon text-muted" />,
        "Conflict Resolver": <FaExclamationTriangle className="tool-icon text-danger " />,
    };

    return (
        <NavLink to={url} className="tool-link">
            <Card className="tool-card">
                <Card.Body className="text-center">
                    <div className="icon-container">{iconMap[toolName] || <FaBox className="tool-icon text-secondary" />}</div>
                    <Card.Title className="tool-title">{toolTitle}
                        {loading && <Loading inline />}
                        {!loading && (count !== null && count !== undefined && count !== 0) && ` (${count})`}
                    </Card.Title>
                </Card.Body>
            </Card>
        </NavLink>
    );
}
